import { Form, Button, Card, Alert } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";
import { FaCircleInfo } from "react-icons/fa6";
import { useState } from "react";
import { userServices } from "../../APIServices/UserData/userServices";
import { authServices } from "../../APIServices/UserData/authServices";

export default function PasswordSetUp({
  setNextPage,
  email,
  name,
  setName,
  setEmail,
  setLoader,
  loader,
  cardAnim,
}) {
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");

  const setUpPassword = async () => {
    setLoader(true);
    let userData = {
      email,
      newPassword,
      repeatPassword,
    };
    let data = await authServices.setUpPassword(userData);
    if (data?.status) {
      setEmail(data?.email);
      setName(data?.name);
      setNextPage(data?.status);
    }
    setLoader(false);
  };

  function getTwoInitials() {
    if (!name) return "";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }
    const first = parts[0][0];
    const last = parts[parts.length - 1][0];
    return (first + last).toUpperCase();
  }

  return (
    <>
      <motion.div key="step4" {...cardAnim}>
        <Card
          className="border-0 shadow-lg"
          style={{ borderRadius: "18px", width: 420 }}
        >
          <Card.Body className="p-4">
            <div className="text-center mb-3">
              <h4 className="fw-bold mb-1">Set your account password</h4>
              <small className="text-muted">
                This password protects your vault — make it strong
              </small>
            </div>
            <Form.Group className="mb-3">
              <div className="hstack gap-2 mb-3">
                  <h6 className={`bg-primary-subtle p-3 rounded-1 fw-bold m-0`}>
                    {getTwoInitials(name)}
                  </h6>
                  <div>
                  <h6 className="m-0">{name}</h6>
                  <p className="small m-0 text-muted">{email}</p>
                </div>  
              </div>
            </Form.Group>

            <Form.Group className="mb-1 floating-group">
              <Form.Control
                type="password"
                required
                placeholder=""
                className="interactive-input"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <Form.Label>Password *</Form.Label>
            </Form.Group>

            <div
              className="d-flex justify-content-between text-muted mb-3"
              style={{ fontSize: 10 }}
            >
              <span>Use at least 8 characters</span>
              <span>{newPassword.length}/8</span>
            </div>

            <Form.Group className="mb-3 floating-group">
              <Form.Control
                type="password"
                required
                placeholder=""
                className="interactive-input"
                value={repeatPassword}
                onChange={(e) => setRepeatPassword(e.target.value)}
              />
              <Form.Label>Confirm Password *</Form.Label>
            </Form.Group>

            <Alert
              variant="info"
              className="d-flex align-items-center gap-2 mb-3"
              style={{ fontSize: 12 }}
            >
              <FaCircleInfo className="text-info" />
              <span>
                For your security, we can’t recover forgotten passwords.
              </span>
            </Alert>

            <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
              <Button
                onClick={setUpPassword}
                disabled={!newPassword || !repeatPassword || loader}
                className="w-100 py-2 fw-bold btn-gradient"
              >
                Continue <FaArrowRight />
              </Button>
            </motion.div>
          </Card.Body>
        </Card>
      </motion.div>
    </>
  );
}
